import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/shared/components/ui/popover";
import { Button } from "@/shared/components/ui/button";
import { Check, ListFilter } from "lucide-react";
import {
  Command,
  CommandGroup,
  CommandItem,
  CommandList,
} from "@/shared/components/ui/command";
import { cn } from "@/shared/lib/utils";
import t from "@/lang/lang";
import { Filter } from "@/shared/lib/filter/filter";
import { Label } from "@/services/backend/processes/api/state";

export interface StateFilterProps {
  filter: Filter<Label> | undefined;
  onFilterChange: (filter: Filter<Label>) => void;
  hidden?: boolean;
}

export function StateFilter({
  filter,
  onFilterChange,
  hidden,
}: StateFilterProps) {
  // This allows us to accept undefined filters,
  // which is common in list requests. This makes
  // it nicer to call the component.
  const filterVal = filter ?? { active: false, values: [] };
  // simplifies some code below
  const currentValues = filterVal.values ?? [];

  if (hidden) {
    return null;
  }

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" size="sm">
          <ListFilter />
          {t("Status")}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="p-0" align="start">
        <Command>
          <CommandList>
            <CommandGroup>
              {Object.values(Label)
                .filter((label) => label !== Label.Unknown)
                .map((label) => (
                  <CommandItem
                    key={label}
                    value={label}
                    onSelect={() => {
                      const values = currentValues.includes(label)
                        ? currentValues.filter((v) => v !== label)
                        : [...currentValues, label];
                      onFilterChange({
                        active: values.length > 0,
                        values,
                      });
                    }}
                  >
                    <Check
                      className={cn(
                        "mr-2 h-4 w-4",
                        currentValues.includes(label)
                          ? "opacity-100"
                          : "opacity-0",
                      )}
                    />
                    {t(label)}
                  </CommandItem>
                ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
